import { MARKETING_SITE_URL } from './logos';

/**
 * Pages that live on the marketing site rather than in this application.
 *
 * <h2>One file, because these URLs appear in several places</h2>
 *
 * The legal pages exist on xtremand.com and nowhere here — there is no `/privacy-policy`
 * route in this router, and `/` redirects into the application. They are linked from the
 * sign-in screen and from the footer of every signed-in page, and a third copy was about to
 * be written when the footer was added. The failure mode of spreading them out is one link
 * quietly pointing somewhere else after a rename nobody could grep for.
 *
 * <p>Built from {@link MARKETING_SITE_URL} rather than written out, so the host is stated
 * once. The previous system keeps the same list in `utils/externalLinks.ts` for the same
 * reason and names the same three pages.
 */
export const EXTERNAL_LINKS = {
  privacyPolicy: `${MARKETING_SITE_URL}/privacy-policy`,
  termsOfService: `${MARKETING_SITE_URL}/terms-of-service`,
  cookiesPolicy: `${MARKETING_SITE_URL}/cookies-policy`,
} as const;

/**
 * What every anchor leaving this application carries.
 *
 * <p>`noopener` is the one that matters: without it the opened page can reach back through
 * `window.opener` and navigate the tab it came from. `noreferrer` goes with it because a
 * browser that does not know `noopener` does know this one, and it implies it.
 */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const;
